import { createElement, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import './index.scss';
const ColorfulRate = props => {
    const { count, allowHalf, defaultValue, readOnly, onChange, ...otherProps } = props;
    const prefixCls = 'au-rate';
    const containerRef = useRef(null);
    const starList = Array(count || 5).fill(null);
    const [value, setValue] = useState(defaultValue);
    const _otherProps = otherProps || {};
    const renderStar = (v, half) => {
        return (createElement("div", { className: classNames(`${prefixCls}-star`, {
                [`${prefixCls}-star-active`]: value >= v,
                [`${prefixCls}-star-half`]: half,
                [`${prefixCls}-star-readonly`]: readOnly,
            }) },
            createElement("i", { className: "icon-solid-star" })));
    };
    const handelClick = (e) => {
        e.persist();
        if (readOnly)
            return;
        const { clientX } = e;
        const container = containerRef.current;
        if (!container)
            return;
        const rect = container.getBoundingClientRect();
        const rawValue = ((clientX - rect.left) / rect.width) * (count || 5);
        const ceiledValue = props.allowHalf
            ? Math.ceil(rawValue * 2) / 2
            : Math.ceil(rawValue);
        setValue(ceiledValue);
        if (onChange) {
            onChange(ceiledValue);
        }
    };
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);
    return (createElement("div", { className: prefixCls, ref: containerRef, ..._otherProps, onClick: handelClick }, starList.map((_, i) => (createElement("div", { key: i, className: `${prefixCls}-box` },
        allowHalf && renderStar(i + 0.5, true),
        renderStar(i + 1, false))))));
};
ColorfulRate.displayName = 'ColorfulRate';
export default ColorfulRate;
